<template>
    <div>
      <router-view></router-view>
      <canvas id="c" width="1500" height="748">
          <div id='btn4'></div>
        </canvas>
    </div>
</template>

<script>

export default {
  name: 'App',
  components: {
    // HelloWorld
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
html{
  font-size: 16px;
}
</style>
